import { GridSetting } from '../../constants/grid.constants';

export class EditGridSettingsData {
  gridSettings: GridSetting;
  gridName: string;
}